import React from 'react'
import Icon from '@mdi/react'
import { mdiCalendarBlank, mdiGoogleMaps, mdiInformation, mdiMapMarker, mdiWaze } from '@mdi/js'
import Logo from '@assets/logo_branco_horizontal.png'
import Button from '@components/Button'
import { useAppSelector } from '@redux/hooks'
import formatDate from '@utils/Date/formatDate'

const ViewDados: React.FC = () => {

    const { convite, geoLocalizacao, dadosConvite } = useAppSelector(s => s.convite)

    const SHOW_DATA = !!convite && !!dadosConvite

    return(

        <div id = "conviteDadosWrapper">

            <div id = "header">
                <img src = {Logo} alt = "Defense Access" />
            </div>

            {SHOW_DATA && (
                <>
                    <div className = "boxContainer">
                        <div id = "title" className = "contentSection">
                            <h1>Olá {dadosConvite.nomeVisitante}</h1>
                            <span>Essa é sua autorização para acessar</span>
                            <h2>{dadosConvite.condominio}</h2>
                        </div>

                        {dadosConvite.flagFoto && (
                            <div id = "avatar" className = "contentSection">
                                <img src = {convite.visitanteCampo.foto} alt = "Foto do visitante" />
                            </div>
                        )}

                        {!dadosConvite.flagFoto && (
                            <div id = "qrcode" className = "contentSection">
                                <img src = {`https://quickchart.io/qr?text=${convite.codigo}&size=200&margin=0`} alt = "convite.codigo" />
                            </div>
                        )}

                        <div id = "data" className = "contentSection">
                            <div className = "listItem">
                                <div className = "titleContainer">
                                    <Icon path = {mdiMapMarker} size = "16px" />
                                    <span>Local</span>
                                </div>

                                <div className = "textContainer">
                                    <span>{dadosConvite?.endereco}</span>
                                </div>
                            </div>

                            <div className = "listItem">
                                <div className = "titleContainer">
                                    <Icon path = {mdiCalendarBlank} size = "16px" />
                                    <span>Período</span>
                                </div>

                                <div className = "textContainer">
                                    <span>{formatDate(dadosConvite.dtInicio)} às {formatDate(dadosConvite.dtFim)}</span>
                                </div>
                            </div>

                            <div className = "listItem">
                                <div className = "titleContainer">
                                    <Icon path = {mdiInformation} size = "16px" />
                                    <span>Quantidade de acessos</span>
                                </div>

                                <div className = "textContainer">
                                    <span>Esse convite é válido para uma entrada e uma saída</span>
                                </div>
                            </div>
                        </div>

                        {/* {(!!geoLocalizacao && !!geoLocalizacao.latitude && !!geoLocalizacao.longitude) && ( */}
                        {(!!geoLocalizacao && !!geoLocalizacao.latitude && !!geoLocalizacao.longitude) && (
                            <div id = "actions" className = "contentSection">
                                <Button
                                    label="Google Maps"
                                    status={"info"}
                                    link={`https://www.google.com/maps/dir//${geoLocalizacao.latitude.replaceAll(',', '.')},${geoLocalizacao.longitude.replaceAll(',', '.')}/@${geoLocalizacao.latitude.replaceAll(',', '.')},${geoLocalizacao.longitude.replaceAll(',', '.')},18z`}
                                    target={'_blank'}
                                    icon={mdiGoogleMaps}
                                    isExternal={true}
                                />

                                <Button
                                    label="Waze"
                                    status={"error"}
                                    link={`https://www.waze.com/ul?ll=${geoLocalizacao.latitude.replaceAll(',', '.')}%2C${geoLocalizacao.longitude.replaceAll(',', '.')}&navigate=yes&zoom=17`}
                                    target={'_blank'}
                                    icon={mdiWaze}
                                    isExternal={true}
                                />
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>

    )

}

export default ViewDados